module.exports = __webpack_public_path__ + "static/media/habilidades_clinicas.845f552f.svg";